<div class="AdminContainer Flexbox Flexbox--column Gap--normal">
  <div class="ControlGroup Flexbox Flexbox--column Gap--smaller">
    <h3>Images</h3>
    <div class="ControlGroupContent Flexbox Flexbox--column Gap--smaller">
      <div class="Control Flexbox Justify--space-between gap--normal">
        <span>File Name Prefix</span>
        <input type="text" [value]="fileNamePrefix" (input)="fileNamePrefix = $any($event.target).value" placeholder="prefix">
      </div>
      <div class="Control Flexbox Justify--space-between gap--normal">
        <span>Product Images</span>
        <button (click)="saveImages()">Save Images</button>
      </div>
      <div class="Control Flexbox Justify--space-between gap--normal">
        <span>Turntable MP4</span>
        <button (click)="saveTurntable()">Save Turntable</button>
      </div>
    </div>
  </div>

  @for (textureInputGroup of textureInputs; track $index) {
    <div class="TextureContainer ControlGroup Flexbox Flexbox--column Gap--smaller">
      <h3>{{ textureInputGroup.title }}</h3>
      <div class="ControlGroupContent Flexbox Flexbox--column Gap--smaller">
        @for (input of textureInputGroup.items; track $index) {
          <div class="Control Flexbox Justify--space-between gap--normal">
            <span>{{ input.title }}</span>
              <label [for]="input.name">
                @if(textureMap().get(input.name.split('|')[0].replace('texture.', ''))) {
                  <span class="FileButton">Replace File</span><span class="FileName">{{textureMap().get(input.name.split('|')[0].replace('texture.', ''))?.name}}</span>
                } @else {
                  <span class="FileButton">Choose File</span>
                }
              </label>
            <input type="file" [name]="input.name" [id]="input.name" accept="image/*" (click)="clearInput($event)" (change)="fileChanged($event)" hidden>
            <button (click)="clearButtonClick(input.name.replaceAll('texture.', ''))">Clear</button>
          </div>
        }
      </div>
    </div>
  }

  <div class="GLBContainer ControlGroup Flexbox Flexbox--column Gap--smaller">
    <h3>Model</h3>
    <div class="ControlGroupContent Flexbox Flexbox--column Gap--smaller">
      <div class="Control Flexbox Justify--space-between gap--normal">
        <span>GLB</span>
        <input type="file" name="model.model" accept=".glb, .gltf" (change)="fileChanged($event)">
      </div>
    </div>
  </div>

  <div class="EnvironmentContainer ControlGroup Flexbox Flexbox--column Gap--smaller">
    <h3>Environment</h3>
    <div class="ControlGroupContent Flexbox Flexbox--column Gap--smaller">
      <div class="Control Flexbox Justify--space-between gap--normal">
        <span>Environment</span>
        <input type="file" name="scene.environment" accept=".hdr, .exr" (change)="fileChanged($event)">
      </div>
      <div class="Control Flexbox Justify--space-between gap--normal">
        <span>Background</span>
        <input type="file" name="scene.background" accept=".hdr, .exr" (change)="fileChanged($event)">
      </div>
    </div>
  </div>
</div>